import React from "react";

const Footer = () => (
  <footer>&copy; 2025 Mellow Enclave LLC · Luxury Beyond Walls</footer>
);

export default Footer;
